
import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import dexfreight, { Microservices } from '../../microservices';
import { MainService } from '../main/main.service'

import { DrayageService } from './drayage.service';
import { AlertsService } from 'src/app/alerts.service';
import { DxcDialogService } from 'src/modules/primitives/dxc';
import { ToastService } from 'src/modules/primitives/toasts/toast.service';
@Injectable({
  providedIn: 'root'
})
export class DrayageNegotiationService {

  constructor(
    private ms: MainService,
    private dialog: MatDialog,
    private drayageService: DrayageService,
    public micro: Microservices,
    private alertsService: AlertsService,
    private dxcDialog: DxcDialogService,
    private toasts: ToastService,
  ) { }



  async acceptOffer(
    hasDocument: boolean,
    loadCompanyId: string,
    drayageId: string,
    offer: any,
    rateProntoPago?: any
  ): Promise<void> {
    const confirmado = await this.dxcDialog.confirm({
      title: 'Aceptar la tarifa final',
      description: 'Con esto cierras la negociación al precio acordado y el flete queda asignado.',
      confirmLabel: 'Aceptar la tarifa',
      cancelLabel: 'Seguir negociando',
    });

    if (!confirmado) return;

    if (hasDocument) {
      try {
        this.ms.toggleLoadingScreen(true)
        const message =
          loadCompanyId === this.ms.company._id
            ? 'Has reservado correctamente esta carga. Revise la documentación proporcionada por el transportista y agregue todos los detalles de la carga. Haga clic en el botón \'Siguiente acción\' para completar los detalles'
            : 'Oferta enviada con éxito.'

        await this.acceptNegotiation(
          drayageId,
          offer,
          message,
          localStorage.token,
          rateProntoPago
        )
      } catch (error) {
        console.log(error);
      } finally {
        setTimeout(() => {
          this.ms.toggleLoadingScreen(false)
        }, 500);
      }
    } else {
      this.alertsService.displayCarrierDocumentUploadRequest()
    }
  }

  getDryServices(drayageId: string, token: string) {
    return dexfreight.Drayage.getServicesDrayageActive(token, drayageId);
  }

  getDryServicesBidding(drayageId: string, token: string) {
    return dexfreight.Drayage.getServicesBidding(drayageId, token);
  }

  addTemporalServicesNegotiation(drayageId: string, carrierCompanyId: string, services: ServiceDry, token: string) {
    return dexfreight.Drayage.addTemporalServicesNegotiation(drayageId, carrierCompanyId, services, token);
  }

  addTemporalService(drayageId: string, service: ServiceDry, token: string) {
    return dexfreight.Drayage.addTemporalServices(drayageId, service, token);
  }

  addChargeablesService(drayageId: string, service: ServiceDry, token: string) {
    return dexfreight.Drayage.addChargeablesServices(drayageId, service, token);
  }

  removeTemporalService(drayageId: string, service: ServiceDry, token: string): any {
    return dexfreight.Drayage.removeServiceTemporal(drayageId, service, token);
  }

  removeServiceTemporalNegotiation(drayageId: string, carrierCompanyId: string, services: ServiceDry, token: string) {
    return dexfreight.Drayage.removeServiceTemporalNegotiation(drayageId, carrierCompanyId, services, token);
  }

  removeChargeablesService(drayageId: string, service: ServiceDry, token: string) {
    return dexfreight.Drayage.removeServiceChargeable(drayageId, service, token);
  }

  async negotiation(loadId, offer, token) {
    try {
      this.ms.toggleLoadingScreen(true)
      await dexfreight.Drayage.negotiation(loadId, offer, token);
      this.toasts.success('Oferta enviada', 'El transportista ya la puede revisar.');
      await this.drayageService.sync(loadId);

    } catch (e) {
      console.log(e);
      this.dxcDialog.failure(e, { doing: 'enviar la oferta' });
    } finally {
      setTimeout(() => {
        this.ms.toggleLoadingScreen(false)
      }, 500);
    }
  }

  async acceptNegotiation(loadId, offer, message, token, rateProntoPago = null) {
    try {
      await dexfreight.Drayage.acceptRate(loadId, offer.id, token, rateProntoPago);
      this.dxcDialog.success({ title: 'Tarifa aceptada', description: message || undefined, closeLabel: 'Continuar' });
    } catch (e) {
      console.log(e);
      this.dxcDialog.failure(e, { doing: 'aceptar la tarifa' });
    }
  }

  async acceptNegotiationFromAutobid(loadId, offer, message, token) {
    try {
      if (!offer.accepted) {
        await dexfreight.Drayage.toBookBid(loadId, offer, localStorage.token)
      } else {
        await dexfreight.Drayage.acceptCarrierBidAsBroker(loadId, offer.id, localStorage.token);
      }
      this.dxcDialog.success({ title: 'Tarifa aceptada', description: message || undefined, closeLabel: 'Continuar' });
      this.updateDrayage(loadId);
    } catch (e) {
      console.log(e);
      this.dxcDialog.failure(e, { doing: 'aceptar la tarifa' });
    }
  }

  async editServices(loadId, payment, token, rateProntoPago = null) {
    try {
      await dexfreight.Drayage.editServices(loadId, payment, token, rateProntoPago);
      this.toasts.success('Precio actualizado', 'Los servicios del flete quedaron con la nueva tarifa.');
      await this.updateDrayage(loadId);
    } catch (e) {
      console.log(e);
      this.dxcDialog.failure(e, { doing: 'actualizar el precio' });
    }
  }

  async updateDrayage(loadId) {
    await this.drayageService.sync(loadId);
    this.ms.listener.dispatchEvent('updatePayment@NewDrayage');
    this.ms.listener.dispatchEvent('Re-GeneratedRate@NewDetails');
    this.ms.listener.dispatchEvent('closeNegotiationEditServicesDialogRef@NewDrayage');
    this.ms.listener.dispatchEvent('closeAutobidModal@NewDrayage');
    this.ms.listener.dispatchEvent('update@drayageList', { show: true });
    this.ms.listener.dispatchEvent('updateNegotiations@NewDrayage');
    this.ms.listener.dispatchEvent('RefreshDocuments@NewDetails');
    this.ms.listener.dispatchEvent('RefreshTopBar@NewDetails');
    this.ms.listener.dispatchEvent('updateServicesPaymentTable@NewDrayage');
    this.ms.listener.dispatchEvent('updatePaymentStatus@NewDrayage');
    this.dialog.closeAll();
  }
}
interface ServiceDry {
  qty: string;
  type: string;
  rate: string;
  units: string;
  active: boolean;
}
